/*
*
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties
* and other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the applicable
* third party licensors or the open source community as the case may be and nothing here transfers the rights to the third party
* and open source components, except as expressly permitted. Any unauthorized reproduction, storage, transmission in any
* form or by any means (including without limitation to electronic, mechanical, printing, photocopying, recording or 
* otherwise), or any distribution of this Program, or any portion of it, may result in severe civil and criminal penalties, and will be
* prosecuted to the maximum extent possible under the law.
* 
*/
import { AfterViewInit, Component, ContentChildren, Directive, ElementRef, Input, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { CarouselItemDirective } from './carousel-item.directive';
import { animate, AnimationBuilder, AnimationFactory, AnimationPlayer, style } from '@angular/animations';

@Directive({
    selector: '.carousel-item',
    standalone: false
})
export class CarouselItemElement {
}

@Component({
    selector: 'carousel',
    exportAs: 'carousel',
    template: `
    <section class="carousel-wrapper" [ngStyle]="carouselWrapperStyle">
      <ul class="carousel-inner" #carousel>
        @for (item of items; track item) {
          <li class="carousel-item">
            <ng-container [ngTemplateOutlet]="item.tpl"></ng-container>
          </li>
        }
      </ul>
      @if (showControls) {
        <i class="left carousel-control material-icons" [ngStyle]="leftArrowStyle" (click)="prev()">keyboard_arrow_left</i>
      }
      @if (showControls) {
        <i class="right carousel-control material-icons" [ngStyle]="rightArrowStyle" (click)="next()">keyboard_arrow_right</i>
      }
    </section>
    `,
    styles: [`
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      width: 6000px;
    }

    .carousel-wrapper {
      overflow: hidden;
      position:relative;
      margin-left:-8px;
      margin-right:-8px;
    }

    .carousel-inner {
      display: flex;
      margin:0px;
    }
    .carousel-item{
      margin-left:8px;
      margin-right:8px;
      padding:0px 0px 3px 0px;
    }
    .carousel-control {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 24px;
      font-size: 24px;
      height: 24px;
      opacity: 0.5;
      text-align: center;
      cursor:pointer;
      background-color:#fafafa;
      box-shadow: 1px 1px 2px 0 rgba(0,0,0,0.10);
    }
    .carousel-control.left {
      left: 0px;
    }
    .carousel-control.right {
      right: 0px;
      left: auto;
    }
    .carousel-control:hover,
    .carousel-control:focus {
       text-decoration: none;
      filter: alpha(opacity=90);
      outline: 0;
      opacity: .9;
    }
  `],
    standalone: false
})
export class CarouselComponent implements AfterViewInit {
  @ContentChildren(CarouselItemDirective) items : QueryList<CarouselItemDirective>;
  @ViewChildren(CarouselItemElement, { read: ElementRef }) private itemsElements : QueryList<ElementRef>;
  @ViewChild('carousel', { static: false }) private carousel : ElementRef;
  @Input() timing = '350ms ease-in';
  @Input() showControls = true;
  @Input() iconPosition : string = '50';
  @Input() leftPosition : string = '0';
  @Input() rightPosition : string = '0';
  private player : AnimationPlayer;
  private itemWidth : number;
  private currentSlide = 0;
  carouselWrapperStyle = {};
  leftArrowStyle = {};
  rightArrowStyle = {};
  iconStyle = {};

  next() {
    if (this.currentSlide + 1 === this.items.length) return;
    this.leftArrowStyle = {
      'top' : this.iconPosition ,
      'left' : this.leftPosition
    };
    this.rightArrowStyle = {
      'top' : this.iconPosition,
      'right' : this.rightPosition
    };
    this.currentSlide = (this.currentSlide + 1) % this.items.length;
    const offset = this.currentSlide * this.itemWidth;
    const myAnimation : AnimationFactory = this.buildAnimation(offset);
    this.player = myAnimation.create(this.carousel.nativeElement);
    this.player.play();
    if( this.currentSlide + 1 === this.items.length ) {
      this.rightArrowStyle = {
        'top' : this.iconPosition,
        'right' : this.rightPosition,
        'display' : 'none'
      };
    };
  }

  private buildAnimation( offset ) {
    return this.builder.build([
      animate(this.timing, style({ transform: `translateX(-${offset}px)` }))
    ]);
  }

  prev() {
    if (this.currentSlide === 0) return;
    this.leftArrowStyle = {
      'top' : this.iconPosition,
      'left' : this.leftPosition
    };
    this.rightArrowStyle = {
      'top' : this.iconPosition,
      'right' : this.rightPosition
    };
    this.currentSlide = ((this.currentSlide - 1) + this.items.length) % this.items.length;
    const offset = this.currentSlide * this.itemWidth;

    const myAnimation : AnimationFactory = this.buildAnimation(offset);
    this.player = myAnimation.create(this.carousel.nativeElement);
    this.player.play();
    if( this.currentSlide === 0 ) {
      this.leftArrowStyle = {
        'top' : this.iconPosition,
        'left' : this.leftPosition,
        'display' : 'none'
      };
    };
  }  

  constructor( private builder : AnimationBuilder ) {
    
  }

  ngAfterViewInit() {
    var strIconPosition = new String(this.iconPosition);
    if(strIconPosition.indexOf('%') == -1){
      this.iconPosition = this.iconPosition+"%";
      this.leftPosition = this.leftPosition + "px";
      this.rightPosition = this.rightPosition + "px";
      this.leftArrowStyle = {
        'top' : this.iconPosition,
        'left' : this.leftPosition
      };
      this.rightArrowStyle = {
        'top' : this.iconPosition,
        'right' : this.rightPosition
      };
    }
    if(this.items.length == 1){
      this.leftArrowStyle = {
        'top' : this.iconPosition,
        'left' : this.leftPosition,
        'display' : 'none'
      };
      this.rightArrowStyle = {
        'top' : this.iconPosition,
        'right' : this.rightPosition,
        'display' : 'none'
      };
    } else if( this.currentSlide + 1 === this.items.length ) {
      this.rightArrowStyle = {
        'top' : this.iconPosition,
        'right' : this.rightPosition,
        'display' : 'none'
      };
    }
    else if( this.currentSlide === 0 ) {
      this.leftArrowStyle = {
        'top' : this.iconPosition,
        'left' : this.leftPosition,
        'display' : 'none'
      };
    };
    // For some reason only here I need to add setTimeout, in my local env it's working without this.
    setTimeout(() => {
      this.itemWidth = this.itemsElements.first.nativeElement.getBoundingClientRect().width + 16;
      this.carouselWrapperStyle = {
        width: `${this.itemWidth}px`
      }
    });
  }

}


